import { useCallback, useEffect, useRef, useState, useMemo } from "react";
import { useForm } from "react-hook-form";
import Modal from "./Modal";
import { useDispatch, useSelector } from "react-redux";
import {
  obtenerPatrocinadores,
  obtenerNivelesBecas,
  obtenerBecas,
  obtenerPatrocinios,
  agregarBecaAdm,
  agregarPatrocinioAdm,
  obtenerSolicitudesBecasPatrocinios,
} from "../../redux/solicitudesAdmSlice";
import WindowDimension from "../../Hooks/WindowDimension";
import { OrderTable } from "../../Components/OrderTable";
import Required from "../../Components/Required";
import useSubmit from "../../Hooks/useSubmit";
import Pagination from "./Paginacion";
import LoadingSpiner from "../../Components/LoadingSpiner";
import { ObtenerTodos } from "../../redux/periodosSlice";
import { getAdminSponsorPage } from "../../Api/content";
import { useLocale } from "../../i18n/localeContext";
import { Skeleton } from "antd";
import { _translateValue } from "../translation-gestor/translateValue";

import { useValidation } from "../../Hooks/useValidation";

const SCREEN_NAME = "PantallaListaBecasPatrocinios";
export default function ListaBecasPatrocinios(props) {
  const { validation } = useValidation();
  const [rowCount, setRowCount] = useState(15);
  const [currentPage, setCurrentPage] = useState(1);

  const { locale } = useLocale();
  const [adminSponsorPage, setAdminSponsorPage] = useState(null);
  const [isLoadingContent, setIsLoadingContent] = useState(true);
  const [translatedNombres, setTranslatedNombres] = useState({});
  const [translatedCarreras, setTranslatedCarreras] = useState({});
  const [translatedAtendidosPor, setTranslatedAtendidosPor] = useState({});
  const [translatedSesiones, setTranslatedSesiones] = useState({});
  const [translatedPeriodos, setTranslatedPeriodos] = useState({});
  const [translatedBecas, setTranslatedBecas] = useState({});
  const [translatedNiveles, setTranslatedNiveles] = useState({});
  const [translatedPatrocinadores, setTranslatedPatrocinadores] = useState({});
  const [translatedPatrocinios, setTranslatedPatrocinios] = useState({});
  const [isTranslating, setIsTranslating] = useState(false);

  const columns = useMemo(() => {
    const sponsorTable = adminSponsorPage?.sponsorApply_table ?? [];
    return [
      { label: sponsorTable[0]?.label || "Solicitud no.", accessor: "numero", sortable: true },
      { 
        label: sponsorTable[1]?.label || "Nombre", 
        accessor: "nombreCompleto", 
        sortable: true,
        render: (item) => (
          <td>{translatedNombres[item.nombreCompleto] || item.nombreCompleto}</td>
        ),
      },
      { label: sponsorTable[2]?.label || "Fecha", accessor: "fechaCreacion", sortable: true },
      { 
        label: sponsorTable[3]?.label || "Carrera", 
        accessor: "carreraNombre", 
        sortable: true,
        render: (item) => (
          <td>{translatedCarreras[item.carreraNombre] || item.carreraNombre}</td>
        ),
      },
      { 
        label: sponsorTable[4]?.label || "Atendido por", 
        accessor: "atendidoPorUsuario", 
        sortable: true,
        render: (item) => (
          <td>{translatedAtendidosPor[item.atendidoPorUsuario] || item.atendidoPorUsuario}</td>
        ),
      },
      { 
        label: sponsorTable[5]?.label || "Sesión", 
        accessor: "sesionNombre", 
        sortable: true,
        render: (item) => (
          <td>{translatedSesiones[item.sesionNombre] || item.sesionNombre}</td>
        ),
      },
      { label: sponsorTable[6]?.label || "Acción", accessor: "action", sortable: false },
    ];
  }, [adminSponsorPage, translatedNombres, translatedCarreras, translatedAtendidosPor, translatedSesiones]);

  const [selectedItem, selectItem] = useState();
  const [itemAssigned, setItemAssigned] = useState(null);

  const [patrocinadores, setPatrocinadores] = useState();
  const [patrocinios, setPatrocinios] = useState();

  const [becas, setBecas] = useState();
  const [niveles, setNiveles] = useState();

  const [periodos, setPeriodos] = useState();
  const [periodoId, setPeriodoId] = useState();
  const [anio, setAnio] = useState();

  const [becaId, setBecaId] = useState();
  const [patrocinadorId, setPatrocinadorId] = useState();
  const [modalState, changeModalState] = useState(false);

  const dispatch = useDispatch();
  const busqueda = useRef();

  const { submitAction } = useSubmit();

  const { solicitudesBecasPatrocinios, loadingSolicitudesBecasPatrocinios } =
    useSelector((state) => state.solicitudesAdm);

  const { width } = WindowDimension();

  const {
    handleSubmit,
    register,
    formState: { errors },
    reset,
    setValue,
  } = useForm();

  const cargarSolicitudes = useCallback(
    (filtro = "") => {
      dispatch(
        obtenerSolicitudesBecasPatrocinios({
          filtro,
          rowCount,
          page: currentPage,
        })
      );
    },
    [currentPage, rowCount]
  );

  useEffect(() => {
    cargarSolicitudes();
  }, [cargarSolicitudes]);

  useEffect(() => {
    dispatch(obtenerPatrocinadores()).then((res) => {
      if (Array.isArray(res.payload)) setPatrocinadores(res.payload);
      else setPatrocinadores([]);
    });
  }, [dispatch]);

  useEffect(() => {
    dispatch(ObtenerTodos()).then((res) =>
      setPeriodos(
        res.payload.filter((x) => parseInt(x.anio) === parseInt(anio))
      )
    );
  }, [anio, dispatch]);

  useEffect(() => {
    if (selectedItem) {
      setPeriodoId(selectedItem?.periodoId);
      setAnio(selectedItem?.anio);
    }
  }, [selectedItem]);

  useEffect(() => {
    if (periodoId && selectItem && anio) {
      dispatch(
        obtenerBecas({
          periodo: periodoId,
          session: selectedItem?.sesionId,
          // selectedItem?.sesionNombre === 'Colones'
          //   ? 'UNICA'
          //   : selectedItem?.sesionNombre.toUpperCase(),
          anio: anio,
        })
      ).then((res) => {
        if (Array.isArray(res.payload)) setBecas(res.payload);
      });
    }
  }, [selectedItem, dispatch, anio, periodoId]);

  useEffect(() => {
    if (patrocinadorId && selectItem) {
      dispatch(
        obtenerPatrocinios({
          periodo: selectedItem?.periodoId,
          anio: selectedItem?.anio,
          patrocinador: patrocinadorId,
          session: selectedItem?.sesionNombre,
        })
      ).then((res) => {
        if (Array.isArray(res.payload)) setPatrocinios(res.payload);
        else setPatrocinios([]);
      });
    }
  }, [patrocinadorId]);

  useEffect(() => {
    if (becaId) {
      setValue("cantidadPeriodos", 1);
      dispatch(obtenerNivelesBecas(becaId)).then((res) => {
        if (Array.isArray(res.payload)) setNiveles(res.payload);
        else setNiveles([]);
      });
    } else {
      setValue("cantidadPeriodos", 0);
    }
  }, [becaId]);

  const closeModal = () => {
    changeModalState(false);
    reset({
      patrocinadorId: null,
      becaId: null,
      patrocinioId: null,
      nivelId: null,
    });
  };
  const openModal = (solicitud, itemType) => {
    setItemAssigned(itemType);
    selectItem(solicitud);
    changeModalState(true);
  };

  const asignarBecaPatrocinio = (data) => {
    let d;
    if (data.patrocinioId) {
      d = {
        patrocinioId: +data.patrocinioId,
        patrocinadorId: data.patrocinadorId,
      };
    } else {
      d = {
        periodoId: data.periodoId,
        becaId: data.becaId,
        nivelId: data.nivelId,
        cantidadPeriodos: data.cantidadPeriodos,
      };
    }
    submitAction(
      data.patrocinadorId ? agregarPatrocinioAdm : agregarBecaAdm,
      { ...d, solicitudId: selectedItem.solicitudId },
      () => {
        cargarSolicitudes();
        closeModal();
      }
    );
  };

  useEffect(() => {
    let cancel = false;
    setIsLoadingContent(true);
    getAdminSponsorPage(locale)
      .then((res) => {
        const data = res?.data?.attributes || res?.data || res;
        if (!cancel) {
          setAdminSponsorPage(data);
          setIsLoadingContent(false);
        }
      })
      .catch(() => { 
        if (!cancel) {
          setAdminSponsorPage(null);
          setIsLoadingContent(false);
        }
      });
    return () => { cancel = true };
  }, [locale])

  // Efecto para traducir los datos de la tabla cuando lleguen o cambie el locale
  useEffect(() => {
    const translateTableData = async () => {
      const hasSolicitudes = solicitudesBecasPatrocinios?.result && Array.isArray(solicitudesBecasPatrocinios.result) && solicitudesBecasPatrocinios.result.length > 0;

      if (!hasSolicitudes) {
        setIsTranslating(false);
        return;
      }

      setIsTranslating(true);

      const nombreTranslations = {};
      const carreraTranslations = {};
      const atendidoPorTranslations = {};
      const sesionTranslations = {};

      const translationPromises = solicitudesBecasPatrocinios.result.map(async (item) => {
        if (item.nombreCompleto) {
          const translated = await _translateValue(SCREEN_NAME, item.nombreCompleto, locale);
          nombreTranslations[item.nombreCompleto] = translated;
        }
        if (item.carreraNombre) {
          const translated = await _translateValue(SCREEN_NAME, item.carreraNombre, locale);
          carreraTranslations[item.carreraNombre] = translated;
        }
        if (item.atendidoPorUsuario) {
          const translated = await _translateValue(SCREEN_NAME, item.atendidoPorUsuario, locale);
          atendidoPorTranslations[item.atendidoPorUsuario] = translated;
        }
        if (item.sesionNombre) {
          const translated = await _translateValue(SCREEN_NAME, item.sesionNombre, locale);
          sesionTranslations[item.sesionNombre] = translated;
        }
      });
      await Promise.all(translationPromises);

      setTranslatedNombres(nombreTranslations);
      setTranslatedCarreras(carreraTranslations);
      setTranslatedAtendidosPor(atendidoPorTranslations);
      setTranslatedSesiones(sesionTranslations);
      setIsTranslating(false);
    };

    translateTableData();
  }, [solicitudesBecasPatrocinios?.result, locale]);

  // Efecto para traducir los periodos cuando lleguen o cambie el locale
  useEffect(() => {
    const translatePeriodos = async () => {
      const hasPeriodos = periodos && Array.isArray(periodos) && periodos.length > 0;

      if (!hasPeriodos) {
        return;
      }

      const periodoTranslations = {};
      const translationPromises = periodos.map(async (item) => {
        if (item.periodoNombre) {
          const translated = await _translateValue(SCREEN_NAME, item.periodoNombre, locale);
          periodoTranslations[item.periodoNombre] = translated;
        }
      });
      await Promise.all(translationPromises);
      setTranslatedPeriodos(periodoTranslations);
    };

    translatePeriodos();
  }, [periodos, locale]);

  // Efecto para traducir las becas cuando lleguen o cambie el locale
  useEffect(() => {
    const translateBecas = async () => {
      const hasBecas = becas && Array.isArray(becas) && becas.length > 0;

      if (!hasBecas) {
        return;
      }

      const becaTranslations = {};
      const translationPromises = becas.map(async (item) => {
        if (item.name) {
          const translated = await _translateValue(SCREEN_NAME, item.name, locale);
          becaTranslations[item.name] = translated;
        }
      });
      await Promise.all(translationPromises);
      setTranslatedBecas(becaTranslations);
    };

    translateBecas();
  }, [becas, locale]);

  // Efecto para traducir los niveles cuando lleguen o cambie el locale
  useEffect(() => {
    const translateNiveles = async () => {
      const hasNiveles = niveles && Array.isArray(niveles) && niveles.length > 0;

      if (!hasNiveles) {
        return;
      }

      const nivelTranslations = {};
      const translationPromises = niveles.map(async (item) => {
        if (item.level) {
          const translated = await _translateValue(SCREEN_NAME, item.level, locale);
          nivelTranslations[item.level] = translated;
        }
      });
      await Promise.all(translationPromises);
      setTranslatedNiveles(nivelTranslations);
    };

    translateNiveles();
  }, [niveles, locale]);

  // Efecto para traducir los patrocinadores cuando lleguen o cambie el locale
  useEffect(() => {
    const translatePatrocinadores = async () => {
      const hasPatrocinadores = patrocinadores && Array.isArray(patrocinadores) && patrocinadores.length > 0;

      if (!hasPatrocinadores) {
        return;
      }

      const patrocinadorTranslations = {};
      const translationPromises = patrocinadores.map(async (item) => {
        if (item.patrocinadorNombre) {
          const translated = await _translateValue(SCREEN_NAME, item.patrocinadorNombre, locale);
          patrocinadorTranslations[item.patrocinadorNombre] = translated;
        }
      });
      await Promise.all(translationPromises);
      setTranslatedPatrocinadores(patrocinadorTranslations);
    };

    translatePatrocinadores();
  }, [patrocinadores, locale]);

  // Efecto para traducir los patrocinios cuando lleguen o cambie el locale
  useEffect(() => {
    const translatePatrocinios = async () => {
      const hasPatrocinios = patrocinios && Array.isArray(patrocinios) && patrocinios.length > 0;

      if (!hasPatrocinios) {
        return;
      }

      const patrocinioTranslations = {};
      const translationPromises = patrocinios.map(async (item) => {
        if (item.patrocinioNombre) {
          const translated = await _translateValue(SCREEN_NAME, item.patrocinioNombre, locale);
          patrocinioTranslations[item.patrocinioNombre] = translated;
        }
      });
      await Promise.all(translationPromises);
      setTranslatedPatrocinios(patrocinioTranslations);
    };

    translatePatrocinios();
  }, [patrocinios, locale]);

  if (isLoadingContent || isTranslating) {
    return (
      <main className="main-admin">
        <div className="main-admin-bar">
          <Skeleton.Input style={{ width: 400, height: 30 }} active />
          <div className="select-filter-section-ml-auto"></div>
          <div className="header-admin-bar-items ml-auto">
            <Skeleton.Input style={{ width: 200, height: 40 }} active />
          </div>
        </div>
        <div className="table-container relative-class">
          <Skeleton.Input style={{ width: '100%', height: 400, minWidth: '800px' }} active />
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
          <Skeleton.Input style={{ width: 300, height: 40 }} active />
        </div>
      </main>
    );
  }

  return (
    <main className="main-admin">
      <div className="main-admin-bar">
        <h2>{adminSponsorPage?.title || "Solicitudes disponibles para becas y patrocinios"}</h2>
        <div className="select-filter-section-ml-auto"></div>
        <div className="header-admin-bar-items ml-auto">
          <label hidden>{adminSponsorPage?.search_input || "Búsqueda"}</label>
          <input
            type="input"
            placeholder={adminSponsorPage?.search_input || "Búsqueda"}
            ref={busqueda}
            className="form-control"
            onChange={(e) => cargarSolicitudes(e.target.value)}
          />
        </div>
      </div>

      <div className="table-container relative-class">
        {loadingSolicitudesBecasPatrocinios && (
          <div className="loading-background">
            <LoadingSpiner
              show
              styles={{
                top: "45%",
                left: "50%",
                width: "50px",
                height: "50px",
                position: "absolute",
                borderWidth: "10px",
                borderStyle: "solid",
                backgroundColor: "rgba(0, 0, 0, 0.3)",
                borderColor: "rgb(27 78 147) rgb(0 0 0) rgb(0 0 0)",
                borderImage: "initial",
              }}
            />
          </div>
        )}
        {solicitudesBecasPatrocinios.result?.length > 0 ? (
          <>
            <OrderTable
              {...{ columns }}
              data={solicitudesBecasPatrocinios.result ?? []}
              clase="table-adm"
              renderActionItems={(item) => {
                return (
                  <td key={Math.random()}>
                    {item?.becaId == null && (
                      <button
                        className="modBtn text-primary "
                        onClick={() => {
                          openModal(item, "beca");
                        }}
                      >
                        <i className="material-icons"></i>
                        {adminSponsorPage?.intership || "Beca"}
                      </button>
                    )}
                    {item?.patrocinioId == null && (
                      <button
                        className="modBtn text-primary "
                        onClick={() => {
                          openModal(item, "patrocinio");
                        }}
                      >
                        <i className="material-icons"></i>
                        {adminSponsorPage?.sponsorType || "Patrocinio"}
                      </button>
                    )}
                  </td>
                );
              }}
            />
          </>
        ) : (
          <div className="no-results-container">
            <img src={props.img} alt="Imagen sin resultados" />
            <h1>{props.noResultMessage}</h1>
          </div>
        )}
      </div>
      <Pagination
        rowCount={rowCount}
        currentPage={currentPage}
        onPageChange={setCurrentPage}
        onRowCountChange={setRowCount}
        totalPages={solicitudesBecasPatrocinios.pageCount ?? 1}
      />
      <Modal
        estado={modalState}
        cambiarEstado={closeModal}
        titulo={adminSponsorPage?.subt_sponsor ||"Asignar beca o patrocinio"}
        clase={`${width < 576 ? "full-width" : "medium"}`}
        buttonGroup={
          <>
            <button
              type="submit"
              className="button-text"
              onClick={handleSubmit(asignarBecaPatrocinio)}
            >
              {adminSponsorPage?.save_button ||"Guardar"}
            </button>
          </>
        }
      >
        <form>
          <div className="grid-container col-2">
            {itemAssigned === "beca" ? (
              <>
                <div className="grid-item">
                  <div className="form-group">
                    <label>{adminSponsorPage?.year ||"Año"}</label>
                    <input
                      className="form-control"
                      type="number"
                      value={anio}
                      onInput={(e) => setAnio(e.target.value)}
                      {...register("anio", {
                        required: validation?.required_field || "Campo requerido",
                      })}
                    />
                    {errors.anio && (
                      <p className="error">{errors.anio.message}</p>
                    )}
                  </div>
                </div>
                <div className="grid-item">
                  <div className="form-group">
                    <label>{adminSponsorPage?.period ||"Periodo de ingreso"}</label>
                    <select
                      className="form-control"
                      value={periodoId}
                      onInput={(e) => setPeriodoId(e.target.value)}
                      {...register("periodoId", {
                        required: validation?.required_field || "Campo requerido",
                      })}
                    >
                      <option value="">{adminSponsorPage?.select_option || "Seleccione"}</option>
                      {periodos?.map((item, i) => {
                        return (
                          <option key={i} value={item.periodoId}>
                            {translatedPeriodos[item.periodoNombre] || item.periodoNombre}
                          </option>
                        );
                      })}
                    </select>
                    {errors.periodoId && (
                      <p className="error">{errors.periodoId.message}</p>
                    )}
                  </div>
                </div>
                <div className="grid-item">
                  <div className="form-group">
                    <label>{adminSponsorPage?.intership ||"Beca"}</label>
                    <Required />
                    <select
                      {...register("becaId")}
                      className="form-control"
                      onChange={(e) => setBecaId(e.target.value)}
                    >
                      <option value="">{adminSponsorPage?.select_option || "Seleccione"}</option>
                      {becas?.map((item, i) => {
                        return (
                          <option key={i} value={item.id}>
                            {translatedBecas[item.name] || item.name}
                          </option>
                        );
                      })}
                    </select>
                    {errors.becaId && (
                      <p className="error">{errors.becaId.message}</p>
                    )}
                  </div>
                </div>
                <div className="grid-item">
                  <div className="form-group">
                    <label>{adminSponsorPage?.level ||"Nivel"}</label>
                    <Required />
                    <select {...register("nivelId")} className="form-control">
                      <option value="">{adminSponsorPage?.select_option || "Seleccione"}</option>
                      {niveles?.map((item, i) => {
                        return (
                          <option key={i} value={item.levelId}>
                            {translatedNiveles[item.level] || item.level}
                          </option>
                        );
                      })}
                    </select>
                    {errors.nivelId && (
                      <p className="error">{errors.nivelId.message}</p>
                    )}
                  </div>
                </div>
                <div className="grid-item">
                  <div className="form-group">
                    <label>{adminSponsorPage?.periodTime ||"Cantidad de periodos a utilizar"}</label>
                    <Required />
                    <input
                    defaultValue={1}
                      type="number"
                      min={1}
                      className="form-control"
                      {...register(`cantidadPeriodos`)}
                    />
                    {errors.cantidadPeriodos && (
                      <p className="error">{errors.cantidadPeriodos.message}</p>
                    )}
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="grid-item">
                  <div className="form-group">
                    <label>{adminSponsorPage?.sponsorName || "Patrocinador"}</label>
                    <Required />
                    <select
                      {...register("patrocinadorId")}
                      className="form-control"
                      onChange={(e) => setPatrocinadorId(e.target.value)}
                    >
                      <option value="">{adminSponsorPage?.select_option || "Seleccione"}</option>
                      {patrocinadores?.map((item, i) => {
                        return (
                          <option key={i} value={item.patrocinadorCode}>
                            {translatedPatrocinadores[item.patrocinadorNombre] || item.patrocinadorNombre}
                          </option>
                        );
                      })}
                    </select>
                    {errors.patrocinadorId && (
                      <p className="error">{errors.patrocinadorId.message}</p>
                    )}
                  </div>
                </div>
                <div className="grid-item">
                  <div className="form-group">
                    <label>{adminSponsorPage?.sponsorType || "Patrocinio"}</label>
                    <Required />
                    <select
                      {...register("patrocinioId")}
                      className="form-control"
                    >
                      <option value="">{adminSponsorPage?.select_option || "Seleccione"}</option>
                      {patrocinios?.map((item, i) => {
                        return (
                          <option key={i} value={item.patrocinioId}>
                            {translatedPatrocinios[item.patrocinioNombre] || item.patrocinioNombre}
                          </option>
                        );
                      })}
                    </select>
                    {errors.patrocinadorId && (
                      <p className="error">{errors.patrocinadorId.message}</p>
                    )}
                  </div>
                </div>
              </>
            )}
          </div>
        </form>
      </Modal>
    </main>
  );
}
